/*
 * The desk's layout (`APP-016`), from `contracts/design/app-desk/`.
 *
 * The canvas draws `grid-template-columns: 1fr 360px` on the two views that have a rail, and
 * a single column at 390. Mobile-first here, so the single column is the default and the rail
 * appears at the width the canvas draws it.
 */

.identity {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-3);
  margin-block-end: var(--space-6);
}

.name {
  font-size: var(--text-2xl);
}

.layout {
  display: grid;
  gap: var(--space-6);
  align-items: start;
}

/* The main column of a view, and the whole of a view that has no rail. */
.column {
  min-inline-size: 0;
  display: grid;
  align-content: start;
}

.rail {
  display: grid;
  gap: var(--space-6);
  align-content: start;
  min-inline-size: 0;
}

/*
 * `min-inline-size: 0` because a grid item's automatic minimum is its content's, and one wide
 * child would otherwise push the fixed rail track past the page edge rather than wrapping
 * inside it.
 */
.railPanel {
  display: grid;
  gap: var(--space-4);
  min-inline-size: 0;
}

.railNote {
  color: var(--text-muted);
  font-size: var(--text-sm);
  max-inline-size: var(--measure);
}

/* A second section within one view. */
.section {
  margin-block-start: var(--space-7);
}

@media (min-width: 64rem) {
  .layout {
    grid-template-columns: minmax(0, 1fr) 22.5rem;
    gap: var(--space-6);
  }
}

.rules {
  display: grid;
  gap: var(--space-4);
}

@media (min-width: 48rem) {
  .rules {
    grid-template-columns: repeat(3, 1fr);
  }
}

.rule {
  display: grid;
  gap: var(--space-2);
  align-content: start;
}

.ruleMark {
  font-family: var(--font-figure);
  font-size: var(--text-xs);
  font-weight: 500;
  letter-spacing: 0.1em;
  color: var(--brass);
}

.ruleTitle {
  font-size: var(--text-lg);
}

.ruleBody {
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.session {
  display: grid;
  gap: var(--space-2);
  margin-block-start: var(--space-6);
  color: var(--text-muted);
  font-size: var(--text-sm);
  max-inline-size: var(--measure);
}
